<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div @click="showUserList=false"
         style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center;">


        <div style="height: 500px;display: flex;    background-image: linear-gradient(45deg,rgb(18 26 45), rgba(123, 223, 228, 0.38));border-radius: 30px;box-shadow: 20px 20px black;position: relative">
            <div class="login-back">
                <img :src="$store.state.backendHost + '/file/logo.png'" style="height: 100px;"
                     ondragstart="return false" alt="">
                <div style="font-size: 1.3rem; font-weight: bolder; padding: 5px;margin: 10px;;color: black;text-align: center">
                    {{ $store.state.title }}
                </div>
            </div>
            <div @click="isLogin=!isLogin"
                  class="login-switch">{{isLogin?'注册':'返回'}}</div>
            <div style="width: 50%;height: 100%; position: relative" v-if="isLogin ===false">


                <el-col style="padding: 50px;display: flex;flex-direction: column;position: relative">
                    
                    <img width="70px" avatar ondragstart="return false" oncontextmenu="return false"
                         style="align-self: center;z-index: 100;border-radius:50%;"
                         :src=" $store.state.backendHost + registerUser.img.split(',')[0]" alt="" @error="userImgDefalt">
                    <el-form label-width="80px" label-position="left" :model="registerUser"
                             style="width: 100%; ">
                        <el-form-item  label="用户名" style="">
                            <el-input v-model="registerUser.username" type="text"
                                      @click.native.stop="inputClick"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" style="">
                            <el-input v-model="registerUser.password" type="text"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名" style="">
                            <el-input v-model="registerUser.name" type="text"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="性别" style="">
                            <el-radio-group v-model="registerUser.sex">
                                <el-radio-button label="0">男</el-radio-button>
                                <el-radio-button label="1">女</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                      
                        <el-form-item label="头像">
                            <multi-img-uploader v-model="registerUser.img"></multi-img-uploader>
                        </el-form-item>

                    </el-form>
                    <el-button style="width: 100%;z-index: 100" v-if="!isLogin" type="success" @click="register">注册
                    </el-button>
                </el-col>
            </div>

            <div style="width: 50%;height: 100%;position: relative" v-if="isLogin">
                <el-col style="padding: 50px;display: flex;flex-direction: column;position: relative;">
                    <img width="70px" avatar ondragstart="return false" oncontextmenu="return false"
                         style="align-self: center;z-index: 100;"
                         :src=" $store.state.backendHost + user.img.split(',')[0]" alt="" @error="userImgDefalt">

                    <el-form label-width="80px" label-position="left" label-color="red" :model="user" style="width: 100%; " >
                        <el-form-item label="用户名" style="margin: 10px 10px;">
                            <el-input v-model="user.username" type="text" @click.native.stop="inputClick"></el-input>

                            <div id="user-list-wrapper" :class="showUserList?'show-user-list':'hide-user-list'">
                                <div class="userList" @click="user=o" v-for="(o,i) in userList" type="primary" :key="i">
                                    {{ o.username }},{{ o.role === 0 ? '管理员' : '用户' }}
                                </div>
                            </div>

                        </el-form-item>
                        <el-form-item label="密码" style="margin: 10px 10px; color:red;">
                            <el-input v-model="user.password" type="password"></el-input>
                        </el-form-item>

                    </el-form>

                    <div style="width: 100%">
                        <el-button style="margin: 25px;width: 100%;z-index: 100;" type="primary" @click="login">登录
                        </el-button>
                    </div>
                </el-col>
            </div>
        </div>


    </div>
</template>
<script>
import MultiImgUploader from "@/components/MultiImgUploader.vue";

export default {
    components: {MultiImgUploader},
    data() {
        return {
            showUserList: false,
            userList: [
                {username: 'admin', role: 0, password: 'admin', name: 'admin', sex: 0, img: '/file/logo.jpg',},
                {username: 'user1', role: 2, password: 'user1', name: '用户1', sex: 0, img: '/file/logo.png',},
                {username: 'user2', role: 2, password: 'user2', name: '用户2', sex: 0, img: '/file/logo.png',},
            ],
            user: {
                username: '',
                password: '',
                name: '',
                sex: 0,
                img: '',
                role: 2,
            },
            registerUser: {
                username: '',
                password: '',
                name: '',
                sex: 0,
                img: '',
                role: 2,
            },
            isLogin: true,
        }
    },
    mounted() {
        let u = JSON.parse(localStorage.getItem('user'))
        this.user = u ? u : this.user
    },
    methods: {


        login() {
            let data = JSON.stringify(this.user)
            this.$axios({
                url: '/system/login',
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((data) => {
                console.log(data)
                let user = data.data
                let path = ""
                if (user.role === 0) path = '/0/'
                if (user.role === 2) path = '/2/'
                if (user.role === -1) {
                    this.$message.error('用户名密码不匹配');
                } else if (user.role === -2) {
                    this.$message.error('用户不存在');
                } else {
                    this.$store.commit("setUser", user)
                    this.$router.replace(path)
                }
            })
        },
        register() {
            if (
                this.registerUser.username === '' ||
                this.registerUser.password === '' ||
                this.registerUser.img === '' ||
                this.registerUser.name === '' ||
                this.registerUser.sex === ''
            ) {
                this.$message.info('信息填写不完整')
                return
            }
            let data = JSON.stringify(this.registerUser)
            this.$axios({
                url: '/user/insert',
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((data) => {
                if (data.data > 0) {
                    this.$message.success('注册成功');
                    this.user = JSON.parse(JSON.stringify(this.registerUser))
                    this.isLogin = true
                    setTimeout(() => {
                        this.login()
                    }, 300)
                } else {
                    this.$message.error('账号已存在');
                }
            })
        },
        inputClick() {
            this.showUserList = !this.showUserList
        },
    }
}
</script>
<style scoped>




/deep/ .el-col img{
    border-radius: 50%
}




/deep/ .el-form-item {
    margin-bottom: 3px !important;
    /*transition-property: height;*/
    /*transition-duration: 0.3s;*/
}

/deep/ .el-input__inner {
    border: none;
    border-radius: 20px !important;
    /*border-left: 1px solid grey;*/

}
/deep/ .el-form-item__label {
    text-align: justify;
    text-justify: inter-ideograph;
    /* background-color: #ffffff; */
    padding-left: 20px;
    color: #ffffff;
}


/deep/ .el-radio-button__inner, .el-radio-group {
    display: block !important;
}

/deep/ .el-button {
    display: block !important;
    height: 40px !important;
    border-radius: 30px !important;
}

/deep/ .el-radio-button:first-child .el-radio-button__inner {
    border: 1px solid transparent !important;
}

/deep/ .el-form-item__content div:nth-last-of-type(1) {
    display: flex;
}

.userList {
    width: 98%;
    padding: 1%;
    cursor: pointer;
    background-color: rgb(18 26 45);
    color: rgb(255, 255, 255);
    height: 30px;
    transition-duration: 0.3s;
    transition-property: background-color;
}

.userList:hover {
    background-color: #000000;
}

/deep/ .el-button {
    border-radius: 20px !important;
}

.about {
    height: 100%;
    width: 100%;
}

/deep/ .el-radio-button__inner {
    border-radius: 10px !important;
}

#user-list-wrapper {
    transition-property: height;
    transition-duration: 0.3s;
    position: absolute;
    background-color: transparent;
    z-index: 110;
    display: block !important;
    overflow-y: hidden;
    width: 100%;
}

#user-list-wrapper::-webkit-scrollbar {
    display: none;

}

.hide-user-list {
    height: 0;
}

.show-user-list {
    height: 200px;
}

.login-back:hover {
    /*backdrop-filter: blur(0);*/
    cursor: pointer;
}

.login-back {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*backdrop-filter: blur(6px);*/
    /*transition-duration: 0.5s;*/
    /*transition-property: backdrop-filter;*/
}
.login-switch{z-index: 101;padding:5px;cursor: pointer;position: absolute;top: 20px;right: 20px;background-color: #88aae7;color: white;border-radius: 10px}
</style>